import type { ObserveLocationEquipmentRef } from '@apis/reports';
import type { EquipmentTypes, UtilityTypes } from '@d-orca/shared/trusstor';
import { getEquipmentIconFromType } from '@utils/equipmentIcons';
import classes from './EquipmentPanel.module.css';

interface IEquipmentRowProps {
  equipment: ObserveLocationEquipmentRef;
}

export function EquipmentRow({ equipment }: IEquipmentRowProps) {
  const iconSrc = getEquipmentIconFromType(
    equipment.type as EquipmentTypes | UtilityTypes,
  );
  return (
    <div className={classes.eqRow}>
      <span className={classes.icon}>
        <img src={iconSrc} alt="" className={classes.iconImg} />
      </span>
      <div className={classes.body}>
        <span className={classes.eqName}>{equipment.name || equipment.equipmentId}</span>
        <span className={classes.eqTypeNick}>
          {equipment.typeNick ?? equipment.type ?? ''}
        </span>
      </div>
    </div>
  );
}
